import { render, staticRenderFns } from "./loginView.vue?vue&type=template&id=28b8fa5f&scoped=true&"
import script from "./loginView.vue?vue&type=script&lang=js&"
export * from "./loginView.vue?vue&type=script&lang=js&"
import style0 from "./loginView.vue?vue&type=style&index=0&id=28b8fa5f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b8fa5f",
  null
  
)

export default component.exports